<template>
    <modal modal_name="delete_feed_item" title="Warning!" icon="trash">
        <template v-slot:modal-content>
            Are you sure you want to delete this? This action is permanent.
        </template>
        <template v-slot:modal-bottom>
            <div class="subtle-button slim" @click="closePopup">
                {{ translations['fields.cancel'] }}
            </div>
            <div class="general-button btn-v2 slim leave-button" @click="deleteFeedItem">
                {{ translations['fields.delete'] }}
                <i class="fa fa-trash"></i>
            </div>
        </template>
    </modal>
</template>

<script>
    import Modal from '../../mixins/v2/Modal';
    import Global from '../../mixins/Global';

    export default {
        name: 'ModalDeleteFeedItem',

        mixins: [Modal, Global],

        methods: {
            deleteFeedItem() {
                const self = this;
                let pluralType = pluralize(this.popup_data.type);

                this.$store.commit('toggleSpinner', true);
                this.closePopup();

                //replies has same endpoint as comments
                if(pluralType === 'replies' || pluralType === 'comments') {
                    pluralType = 'comments';
                } else {
                    //topics is conversations in the routing
                    pluralType = 'conversations';
                }

                //delete item
                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: this.popup_data.type,
                            crud_method: 'delete',
                            //sub_path: '/v2/' + pluralType + '/' + item.id + '/delete',
                            sub_path: '/' + pluralType + '/' + this.popup_data.item.id,
                            save_data: { id: this.popup_data.item.id },
                            success_callback: function () {
                                self.$store.commit('toggleSpinner', false);
                            },

                            failure_callback: function () {
                                self.$store.commit('toggleSpinner', false);
                            }
                        }
                    }
                );

                //decrease the posts' comments count
                if (this.popup_data.type !== 'topic') {
                    if(this.popup_data.type === 'comment') {
                        self.$store.commit('postCommentsCount', [this.popup_data.item.topic(), 'decrement']);
                    } else if(this.popup_data.type === 'reply') {
                        self.$store.commit('postCommentsCount', [this.popup_data.type.item.comment().topic(), 'decrement']);
                    }
                }
            },
        },
    };
</script>
